module.exports = __webpack_public_path__ + "static/media/quequenFinal.fda5da92.webp";